



import React from "react";

export const ChevronUpIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-3.5 h-3.5 text-gray-100",
    ...props
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" className={className} {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M2.19559 9.13811C1.93524 8.87776 1.93524 8.45565 2.19559 8.1953L6.19559 4.1953C6.45594 3.93495 6.87805 3.93495 7.1384 4.1953L11.1384 8.1953C11.3987 8.45565 11.3987 8.87776 11.1384 9.13811C10.878 9.39846 10.4559 9.39846 10.1956 9.13811L6.66699 5.60952L3.1384 9.13811C2.87805 9.39846 2.45594 9.39846 2.19559 9.13811Z" fill="currentColor" />
        </svg>

    );
};